export class TokenManager {
  validateFormat(token) {
    console.log('TokenManager.validateFormat - Validating token format');
    
    if (!token || typeof token !== 'string') {
      console.log('TokenManager.validateFormat - Token is not a string');
      return { isValid: false, error: 'Token inválido' };
    }

    // Remove whitespace
    token = token.trim();
    console.log('TokenManager.validateFormat - Token length:', token.length);
    console.log('TokenManager.validateFormat - Token starts with:', token.substring(0, 10) + '...');

    if (token.length === 0) {
      console.log('TokenManager.validateFormat - Token is empty');
      return { isValid: false, error: 'Token vacío' };
    }

    // Check if token is a JWT-like Base64 encoded token (starts with ey)
    if (token.startsWith('ey')) {
      console.log('TokenManager.validateFormat - Token is a Base64 JWT-like token (school login)');
      try {
        // Try to decode and parse the token
        const decoded = atob(token);
        const parsed = JSON.parse(decoded);
        
        // Check if it has the expected fields
        if (parsed.id && parsed.email && parsed.type === 'school' && parsed.exp) {
          console.log('TokenManager.validateFormat - Valid school token format');
          return { isValid: true };
        }
      } catch (error) {
        console.log('TokenManager.validateFormat - Error parsing JWT-like token:', error);
        return { isValid: false, error: 'Token JWT inválido' };
      }
    }

    // If not a JWT, validate ACC-XXXXXXXX-YYYY format (for student tokens)
    const tokenRegex = /^ACC-[A-F0-9]{8}-[0-9]{4}$/;
    const isValidFormat = tokenRegex.test(token);
    console.log('TokenManager.validateFormat - Regex test result:', isValidFormat);
    
    if (!isValidFormat) {
      return { isValid: false, error: 'Formato de token inválido' };
    }

    return { isValid: true };
  }

  parseToken(tokenData) {
    if (!tokenData || !tokenData.token) {
      return { isValid: false, error: 'Datos de token inválidos' };
    }

    try {
      console.log('TokenManager.parseToken - Raw token:', tokenData.token);
      console.log('TokenManager.parseToken - Token type:', tokenData.type);
      
      // Validate token format
      const formatValidation = this.validateFormat(tokenData.token);
      console.log('TokenManager.parseToken - Format validation result:', formatValidation);
      
      if (!formatValidation.isValid) {
        return formatValidation;
      }

      // For school tokens (JWT format), check expiration from the decoded token
      if (tokenData.type === 'school' && tokenData.token.startsWith('ey')) {
        try {
          const decoded = atob(tokenData.token);
          const parsed = JSON.parse(decoded);
          
          // Check if token has expired
          if (parsed.exp) {
            const now = Math.floor(Date.now() / 1000);
            if (parsed.exp < now) {
              console.log('TokenManager.parseToken - JWT token expired:', {
                now,
                exp: parsed.exp
              });
              return { isValid: false, error: 'Token expirado' };
            }
          }
        } catch (error) {
          console.log('TokenManager.parseToken - Error checking JWT expiration:', error);
          return { isValid: false, error: 'Error al verificar expiración del token' };
        }
      }
      // For student tokens or other types, check the expiresAt field
      else if (tokenData.expiresAt && new Date(tokenData.expiresAt) < new Date()) {
        console.log('TokenManager.parseToken - Token expired via expiresAt field');
        return { isValid: false, error: 'Token expirado' };
      }

      return { isValid: true };
    } catch (error) {
      console.error('Error parsing token:', error);
      return { isValid: false, error: 'Error al procesar el token' };
    }
  }
}